// Outcome tracking foundation — structures behavioral data for future learning

const STORAGE_KEY = "decision-os-outcomes";

export interface OutcomeEvent {
  timestamp: string;
  type: "click" | "ignore" | "save" | "track_price" | "alert";
  query: string;
  category: string;
  optionId: string;
  optionLabel: string;
  country?: string;
}

function getEvents(): OutcomeEvent[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function saveEvents(events: OutcomeEvent[]): void {
  try {
    // Keep last 100 events
    localStorage.setItem(STORAGE_KEY, JSON.stringify(events.slice(-100)));
  } catch {
    // silently fail
  }
}

export function trackOutcome(event: Omit<OutcomeEvent, "timestamp">): void {
  const events = getEvents();
  events.push({ ...event, timestamp: new Date().toISOString() });
  saveEvents(events);
}

export function getOutcomeSummary() {
  const events = getEvents();
  const clicks = events.filter((e) => e.type === "click");
  const byLabel: Record<string, number> = {};
  clicks.forEach((e) => {
    byLabel[e.optionLabel] = (byLabel[e.optionLabel] || 0) + 1;
  });
  return {
    totalQueries: new Set(events.map((e) => e.query)).size,
    totalClicks: clicks.length,
    preferredLabel: Object.entries(byLabel).sort((a, b) => b[1] - a[1])[0]?.[0],
    categoryDistribution: events.reduce(
      (acc, e) => ({ ...acc, [e.category]: (acc[e.category] || 0) + 1 }),
      {} as Record<string, number>
    ),
  };
}
